var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 150,
    viewBox: "0 0 197 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4555_119675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.421 149.005H52.8321C49.3782 149.005 46.5781 146.205 46.5781 142.751V16.9104C46.5781 7.70454 54.0405 0.242188 63.2463 0.242188H180.334C189.54 0.242188 197.002 7.70454 197.002 16.9104V135.424C197.002 142.926 190.922 149.005 183.421 149.005Z",
    fill: "url(#paint0_linear_4555_119675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8321 149.003H183.421C190.922 149.003 197.002 142.922 197.002 135.422V27.9354L184.015 14.948C181.894 12.5808 178.814 11.0898 175.386 11.0898H47.6242C46.9494 12.9009 46.5781 14.8608 46.5781 16.9079V142.749C46.5781 146.203 49.3782 149.003 52.8321 149.003Z",
    fill: "url(#paint1_linear_4555_119675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6329 12.4101C55.9325 19.6274 62.6373 24.5272 70.2124 24.5272H116.393C115.783 24.5272 115.179 24.4926 114.581 24.4295L95.8324 5.69321C92.6205 2.32351 88.11 0.292969 83.2358 0.292969H63.5797C58.2666 0.292969 53.5112 2.67822 50.3203 6.43269C51.7782 8.1506 52.919 10.1676 53.6329 12.4101Z",
    fill: "url(#paint2_linear_4555_119675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.388 149.004H23.207C16.8103 149.004 11.625 143.819 11.625 137.422V22.6719C11.625 16.2752 16.8103 11.0898 23.207 11.0898H175.388C181.785 11.0898 186.97 16.2752 186.97 22.6719V137.422C186.97 143.819 181.785 149.004 175.388 149.004Z",
    fill: "url(#paint3_linear_4555_119675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.852 29.9862C167.681 26.627 163.188 24.5273 158.203 24.5273H11.625V137.421C11.625 143.818 16.8103 149.004 23.207 149.004H175.388C181.785 149.004 186.97 143.818 186.97 137.421V46.1043L170.852 29.9862Z",
    fill: "url(#paint4_linear_4555_119675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6339 12.411C55.9335 19.6283 62.6383 24.5281 70.2134 24.5281H116.394C115.784 24.5281 115.18 24.4935 114.582 24.4304L101.234 11.0898H53.1484C53.3258 11.5227 53.4911 11.9601 53.6339 12.411Z",
    fill: "url(#paint5_linear_4555_119675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.856 28.9144V24.5272H116.393C108.82 24.5272 102.115 19.6274 99.8154 12.4101C97.5158 5.19272 90.811 0.292969 83.2359 0.292969H63.5798C53.9712 0.292969 46.1797 8.08297 46.1797 17.6931V28.9144H117.856Z",
    fill: "url(#paint6_linear_4555_119675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6342 12.4101C51.3346 5.19272 44.6298 0.292969 37.0562 0.292969H17.4001C7.79 0.292969 0 8.08297 0 17.6931V131.82C0 141.31 7.69381 149.003 17.1837 149.003H180.35C177.726 149.003 175.599 146.877 175.599 144.252V41.9273C175.599 32.3187 167.809 24.5272 158.199 24.5272H70.2137C62.6386 24.5272 55.9338 19.6274 53.6342 12.4101Z",
    fill: "url(#paint7_linear_4555_119675)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4555_119675",
    x1: 155.892,
    y1: -15.6258,
    x2: 120.528,
    y2: 79.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B89D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#AE9351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#A88D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#8D763C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#907C4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4555_119675",
    x1: 158.12,
    y1: 122.954,
    x2: 93.6512,
    y2: 58.4858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3074,
    stopOpacity: 0.305882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    stopOpacity: 0.678431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4555_119675",
    x1: 108.629,
    y1: 43.458,
    x2: 58.5534,
    y2: -6.61782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3074,
    stopOpacity: 0.305882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    stopOpacity: 0.678431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4555_119675",
    x1: 99.2971,
    y1: -37.9687,
    x2: 99.2971,
    y2: 150.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4555_119675",
    x1: 185.786,
    y1: 95.7405,
    x2: 136.736,
    y2: 91.1039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F9F9F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6699,
    stopColor: "#9F9F9F",
    stopOpacity: 0.670588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4555_119675",
    x1: 108.129,
    y1: 42.9575,
    x2: 62.5501,
    y2: -2.62122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B5D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6699,
    stopColor: "#8190A4",
    stopOpacity: 0.670588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4555_119675",
    x1: 82.0186,
    y1: 4.20935,
    x2: 82.0186,
    y2: 24.4305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2277,
    stopColor: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#FF3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7098,
    stopColor: "#FF3434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9554,
    stopColor: "#E62727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4555_119675",
    x1: 90.1749,
    y1: 76.2111,
    x2: 90.1749,
    y2: 157.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0995E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#AD9457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#A48C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#978250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#907C4B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4555_119675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.6ddc8ca859dfc4a0243efe36189338e1.svg";
export { ForwardRef as ReactComponent };